// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IoLockClosedOutline = function IoLockClosedOutline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","d":"M336 208v-95a80 80 0 00-160 0v95"}},{"tag":"rect","attr":{"width":"320","height":"272","x":"96","y":"208","fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"32","rx":"48","ry":"48"}}]})(props);
};
